/* eslint-disable */
export default {
    0: {
        add_success: '添加自选成功',
        add_failed: '添加自选失败',
        remove_success: '已删除自选',
        remove_failed: '删除自选失败',
        load_failed: '数据加载失败',
        iv_data_title: '隐含波动率',
        volume_data_title: '成交量',
        open_int_data_title: '持仓量',
        no_data_title: '当前筛选条件下暂无数据，请调整筛选条件。'
    },
    1: {
        add_success: '添加自選成功',
        add_failed: '添加自選失败',
        remove_success: '已刪除自選',
        remove_failed: '刪除自選失败',
        load_failed: '數據加載失敗',
        iv_data_title: '隱含波動率',
        volume_data_title: '成交量',
        open_int_data_title: '持倉量',
        no_data_title: '當前篩選條件下暫無數據，請調整篩選條件。'
    },
    2: {
        add_success: 'Added to watchlist successfully',
        add_failed: 'Failed to add to watchlist',
        remove_success: 'Removed from watchlist',
        remove_failed: 'Failed to remove from watchlist',
        load_failed: 'Loading failed',
        iv_data_title: 'Implied Volatility',
        volume_data_title: 'Volume',
        open_int_data_title: 'Open Interest',
        no_data_title: 'No data is available under the current filter settings. Please adjust the filter criteria.'
    },
    5: {
        add_success: 'お気に入りに追加しました',
        add_failed: 'お気に入りに追加できませんでした',
        remove_success: 'お気に入りから削除しました',
        remove_failed: 'お気に入りから削除できませんでした',
        load_failed: 'データの読み込みに失敗しました',
        iv_data_title: 'IV',
        volume_data_title: '出来高',
        open_int_data_title: '未決済建玉',
        no_data_title: '現在の絞り込み条件では該当するデータがありません。条件を調整してください。'
    }
};
